<div class="date">
  <div class="day-text">{{ event.start | date: 'EEEE' }}</div>
  <div class="day">{{ event.start | date: 'd' }}</div>
  <div class="month">{{ event.start | date: 'MMMM' }}</div>
</div>

<div class="separator color-separator"></div>

<div class="main-content">
  <a href="#" class="event-title" (click)="openEvent($event)">{{ event.title }}</a>
  <div class="event-date-label">{{event.eventData.description}}</div>
  <div class="event-date">
    <mat-icon [svgIcon]="'clock'" class="square-icon event-icon"></mat-icon>

    {{ event.eventData.date | date: "dd/MM/yyyy" }}<br/>
      <span *ngIf="!isTimeEmpty(event.eventData.date)">{{ event.eventData.date | date: "HH:mm" }}</span>
  </div>
</div>

<div class="notifications" *ngIf="event.eventData.notifications && event.eventData.notifications.length">
  <a class="notification-link">
    <mat-icon [svgIcon]="'bell-point'" class="notification-icon"></mat-icon>
  </a>
</div>